import styled from "styled-components";
import {SearchClearIconDefaultBox} from "./search-clear-icon.default.box";

export const SearchClearIconCasino777Box = styled(SearchClearIconDefaultBox)`
    background-position: -585px -519px;
`;